import { useQuery } from "@tanstack/react-query";
import { Agent } from "@/model";
import agentRepository from "@/repository/agentRepository";
import { agentQueryKeys } from "./keys";


const getData = async (id?: number) => {
    if (!id) {
        return null;
    }
    const res = await agentRepository.read(id as number);
    return res.data.data;
};

export const useAgent = (agentId?: number) => {
    return useQuery<Agent>({
        queryKey: agentQueryKeys.read(agentId ?? -1),
        queryFn: async () => getData(agentId),
        retry: false
    });
};
